<template>
    <div class="l-edit-dialog-box">
        <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left">
            <el-form-item label="应用" prop="app_id">
                <el-select v-model="form_data.app_id" placeholder="请选择应用">
                    <el-option :label="item" :value="parseInt(index)" v-for="(item, index) in app_list"
                        :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form_data.mobile" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="用户id" prop="bind_DisplayId">
                <el-input v-model="form_data.bind_DisplayId" autocomplete="off" placeholder="请输入用户id"></el-input>
            </el-form-item>
        </el-form>
        <div class="l-dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "admin-bind-user",
    props: {
        visible: {
            type: Boolean,
        },
    },
    computed: {
        hasId() {
            return this.$props.id !== null;
        },
    },

    data() {
        return {
            app_list:
            {
                1: "星伴"
            },
            //表单数据
            form_data: {
                mobile: "",
                bind_DisplayId: "",
                app_id: 1
            },
            //表单验证规则
            rules: {
                app_id: [{ required: true, message: "请选择应用", trigger: "change" }],
                mobile: [{ required: true, message: "手机号不能为空", trigger: "change" }],
                bind_DisplayId: [{ required: true, message: "用户ID不能为空", trigger: "change" }],
            },
            submitting: false,
        };
    },

    methods: {
        //点击取消通知父组件关闭对话框
        cancel() {
            this.$emit("on-success");
        },
        //提交数据
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    this.$_invoke('home_bind', this.form_data)
                        .then(() => {
                            this.$_msg.success("绑定成功");
                            this.$emit("on-success");
                        })
                        .finally(() => {
                            this.submitting = false;
                        });
                }
            });
        },
    },
};
</script>
